module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("BL List Dashboard")]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted justify-content-center"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])])], 1), _vm._v(" "), _c('div', [_c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-card', [_c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.clientIdFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientIdFilter", $$v)
      },
      expression: "Filter.clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Date :")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate
    },
    on: {
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.PORfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PORfilter", $$v)
      },
      expression: "Filter.PORfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPODList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.PODfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PODfilter", $$v)
      },
      expression: "Filter.PODfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.shippingLineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "shippingLineFilter", $$v)
      },
      expression: "Filter.shippingLineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("POL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPOLList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POL"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'PortLoadList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'PortLoadList')
      },
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.LPlocationId),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "LPlocationId", $$v)
      },
      expression: "Filter.LPlocationId"
    }
  })], 1), _vm._v(" "), _c('b-col', [_c('label', [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllLocationDetailsFinalList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select FPOD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.finalPlaceLocationId),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "finalPlaceLocationId", $$v)
      },
      expression: "Filter.finalPlaceLocationId"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchfilter", $$v)
      },
      expression: "Filter.branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Agent Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAgentColoaderList'],
      "id": "ToFilter",
      "option-value": "agentName",
      "option-text": "agentName",
      "placeholder": "All"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.ToFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ToFilter", $$v)
      },
      expression: "Filter.ToFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Consignee")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllConsigneeList'],
      "id": "Consignee",
      "option-value": "consignee",
      "option-text": "consignee",
      "placeholder": "Select Consignee"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.Consignee),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "Consignee", $$v)
      },
      expression: "Filter.Consignee"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Consignor")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllConsignorList'],
      "id": "Consignor",
      "option-value": "consignorName",
      "option-text": "consignorName",
      "placeholder": "Select Consignor"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.Consignor),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "Consignor", $$v)
      },
      expression: "Filter.Consignor"
    }
  })], 1), _vm._v(" "), _c('b-col', [_c('label', [_vm._v("Assignment No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Assignment No.",
      "id": "assignmentNo",
      "name": "assignmentNo"
    },
    model: {
      value: (_vm.Filter.assignmentNo),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "assignmentNo", $$v)
      },
      expression: "Filter.assignmentNo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 row justify-content-center"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.SearchFilter
    }
  }, [_vm._v("Search\n              ")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("clear")]), _vm._v(" "), (_vm.All_BL_List_data.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('BLDashboard')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n                "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-2"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.All_BL_List_data,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection,
      "responsive": "",
      "primary-key": "fclBlId"
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "ffExportFclId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "blStage",
      fn: function(row1) {
        return [_c('b', {
          staticClass: "text-danger",
          on: {
            "click": function($event) {
              _vm.viewEditBLNonUs(row1.item)
            }
          }
        }, [_vm._v(_vm._s(row1.item.BlNumber))]), _c('br'), _vm._v(" "), _c('b-button', {
          staticClass: "text-danger",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "outline-warning",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.PrintNote(row1.item.uploadBL, row1.item.assignment_number)
            }
          }
        }, [_vm._v("PDF")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(row1.item.blDate))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("BL Stage: "), _c('b', [_vm._v(_vm._s(row1.item.blStage))])]), _vm._v(" "), _c('span', [_vm._v("BL Created By: "), _c('b', [_vm._v(_vm._s(row1.item.BlRaisedBy))])]), _vm._v(" "), _c('span', [_vm._v("BL Created AT: "), _c('b', [_vm._v(_vm._s(row1.item.BlCreatedAt))])])]
      }
    }, {
      key: "AssignementDetails",
      fn: function(row21) {
        return [_c('b', [_vm._v("Assignement Number : " + _vm._s(row21.item.assignment_number))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Assignement Date : " + _vm._s(_vm._f("moment")(row21.item.assigement_date)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Raised From : " + _vm._s(row21.item.RasiedFrom))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Rasied By : " + _vm._s(row21.item.username))])]
      }
    }, {
      key: "POR",
      fn: function(row3) {
        return [_c('span', [_c('b', [_vm._v("POD")]), _vm._v(" : " + _vm._s(row3.item.POD))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("POL")]), _vm._v(" : " + _vm._s(row3.item.POL))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("POR")]), _vm._v(" : " + _vm._s(row3.item.POR))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("FPOD")]), _vm._v(" : " + _vm._s(row3.item.FPOD))]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "clientName",
      fn: function(row4) {
        return [_c('span', [_vm._v("Client Name : "), _c('b', [_vm._v(_vm._s(row4.item.clientName))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Shipper Name : "), _c('b', [_vm._v(_vm._s(row4.item.ShippingLine))])])]
      }
    }, {
      key: "ConsoleBooking",
      fn: function(row5) {
        return [(
          row5.item.sob_date_detected != '' && row5.item.sob_date_detected != null
        ) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_c('b', [_vm._v("SOB :")]), _vm._v(" " + _vm._s(row5.item.sob_date_detected))]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v("SAILED")])]), _c('br')], 1) : _vm._e(), _vm._v(" "), (row5.item.vessel_voyage) ? _c('span', [_c('b', [_vm._v("Vessel : ")]), _vm._v(_vm._s("" + row5.item.vessel_voyage))]) : _c('div', [(row5.item.ConsoleBooking.vesselName) ? _c('span', [_c('b', [_vm._v("Vessel Name : ")]), _vm._v(_vm._s("" + row5.item.ConsoleBooking.vesselName))]) : _vm._e(), _c('br'), _vm._v(" "), (row5.item.ConsoleBooking.voyageNo) ? _c('span', [_c('b', [_vm._v("Voyage No : ")]), _vm._v(_vm._s("" + row5.item.ConsoleBooking.voyageNo))]) : _vm._e()])]
      }
    }, {
      key: "SubscriptionID",
      fn: function(row6) {
        return [_c('b', {
          on: {
            "click": function($event) {
              row6.item.SubscriptionID &&
                row6.item.subscription_status_detials_status == 1 ?
                _vm.trackingRed(row6.item.SubscriptionID) :
                ''
            }
          }
        }, [_c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(_vm._s(row6.item.SubscriptionID))]), _c('br')], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(row6.item.subscription_status_detials)), _c('br')]), _vm._v(" "), _c('span', [_vm._v(_vm._s(row6.item.Subscription_CreateDate))])]
      }
    }, {
      key: "vgmSubmissionDate",
      fn: function(row7) {
        return [(row7.item.vgmSubmissionDate) ? _c('span', [_c('b', [_vm._v("VGM :")]), _vm._v(" " + _vm._s(row7.item.vgmSubmissionDate)), _c('br')]) : _vm._e(), _vm._v(" "), (row7.item.siSubmissionDate) ? _c('span', [_c('b', [_vm._v("SI :")]), _vm._v(" " + _vm._s(row7.item.siSubmissionDate))]) : _vm._e()]
      }
    }, {
      key: "Payment_Status",
      fn: function(row8) {
        return [_c('span', [_vm._v(_vm._s(row8.item.Payment_Status))])]
      }
    }, {
      key: "description",
      fn: function(row9) {
        return [(row9.item.ConsoleBooking.vessel_sale_start_date) ? _c('span', [_c('b', [_vm._v("Sale Date : ")]), _vm._v(_vm._s("" + row9.item.ConsoleBooking.vessel_sale_start_date))]) : _vm._e(), _c('br'), _vm._v(" "), (row9.item.ConsoleBooking.sicutoff) ? _c('span', [_c('b', [_vm._v("SI CUT Date : ")]), _vm._v(_vm._s("" + row9.item.ConsoleBooking.sicutoff))]) : _vm._e(), _c('br'), _vm._v(" "), (row9.item.ConsoleBooking.vesselEta) ? _c('span', [_c('b', [_vm._v("Vessel ETA : ")]), _vm._v(_vm._s("" + row9.item.ConsoleBooking.vesselEta))]) : _vm._e(), _c('br'), _vm._v(" "), (row9.item.ConsoleBooking.vesselEtd) ? _c('span', [_c('b', [_vm._v("Vessel ETD : ")]), _vm._v(_vm._s("" + row9.item.ConsoleBooking.vesselEtd))]) : _vm._e(), _c('br')]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "20",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-462fb2a2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/blListDash.vue
// module id = 2576
// module chunks = 0